import { footerLinks } from '@/mocks/homeData';

export default function Footer() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <a
              href="#hero"
              onClick={(e) => { e.preventDefault(); handleClick('#hero'); }}
              className="inline-flex items-center gap-2 mb-4 cursor-pointer"
            >
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-2-fill text-background-50 text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50 tracking-tight">
                51影院
              </span>
            </a>
            <p className="text-sm text-background-400 leading-relaxed max-w-xs">
              51影院整合第九影院、yy影院、看吧影院、九九影院、18影院等优质资源，
              提供免费高清在线观影服务，每日更新海量影片，纯净无广告。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">
              快速导航
            </h4>
            <nav className="flex flex-col gap-2">
              {footerLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => { e.preventDefault(); handleClick(link.href); }}
                  className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">
              合作伙伴
            </h4>
            <p className="text-sm text-background-500">
              合作伙伴信息即将上线，敬请期待。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">
              免责声明
            </h4>
            <p className="text-xs text-background-500 leading-relaxed">
              本站内容来源于网络公开资源，仅供交流学习使用。如涉及版权问题请联系我们处理。51影院不存储任何视频文件，所有内容均来自第三方平台。
            </p>
          </div>
        </div>

        <div className="mt-10 md:mt-12 pt-6 border-t border-background-700 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 51影院 - 第九影院与yy影院免费高清在线看。保留所有权利。
          </p>
          <p className="text-xs text-background-600">
            每日更新 · 纯净观影 · 永久免费
          </p>
        </div>
      </div>
    </footer>
  );
}